var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"journal-v"},[_c('div',{staticClass:"cont"},[_c('ComTitle',{attrs:{"show-more":true,"titleEn":"JOURNAL INTRODUCTION","titleZh":"统计学会期刊介绍","zhColor":"#333333"},on:{"more":_vm.more}}),_c('JournalCover')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }